import { Debouncer } from "@tanstack/react-pacer";
import EventEmitter from "./EventEmitter";

type EventTypes = "resize";

const WAIT = 100;

export default class Sizes extends EventEmitter<EventTypes> {
    width: number = 0;
    height: number = 0;
    pixelRatio: number = 0;
    aspectRatio: number = 0;

    #observer: ResizeObserver;

    constructor(element: HTMLElement) {
        super();

        const container = element.parentElement ?? element;

        this.#setSizes(container);

        const debouncer = new Debouncer(
            () => {
                this.#setSizes(container);
                this.trigger("resize");
            },
            { wait: WAIT },
        );

        this.#observer = new ResizeObserver(() => {
            debouncer.maybeExecute();
        });

        this.#observer.observe(container);
    }

    destroy() {
        this.#observer.disconnect();
    }

    #setSizes = (element: HTMLElement): void => {
        this.width = element.clientWidth;
        this.height = element.clientHeight;
        this.pixelRatio = Math.min(window.devicePixelRatio, 2);
        this.aspectRatio = this.width / this.height;
    };
}
